import React, { useEffect, useRef, useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  Container,
  Grid,
  TextField,
  Select,
  MenuItem,
} from "@material-ui/core";
import Box from '@mui/material/Box';
import Button from "@material-ui/core/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { generateBookingFilterUrl } from "../../helpers/generateUrl";
import { connect } from "react-redux";
import {
  getAgentList,
  getPartners,
  getAllBookings,
  getCities,
  getPhlebos,
  getCenterInfo,
} from "../actions/GenomicsAdminAction";
import { getLeadSource } from "../actions/GenomicsAdminAction";
import "./filter.sass";
import { useHistory } from "react-router";
import BookingsTable from "../Tables/bookingsTable";
import Loader from "../Components/loader";
const BILLING_STATUS = [
  {
    text: "Pending",
    value: "pending",
  },
  {
    text: "Confirmed",
    value: "confirmed",
  },
  {
    text: "Cancelled",
    value: "cancelled",
  },
  {
    text: "Rescheduled",
    value: "rescheduled",
  },
  {
    text: "Resampling",
    value: "resampling",
  },
  {
    text: "Sample Not Received Due To Payment Information",
    value: "Sample Not Received Due To Payment Information",
  },
  {
    text: "Sample Received",
    value: "sample received",
  },
  {
    text: "Partial Received",
    value: "partial received",
  },
];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
      //   width: "100%",
      //   marginTop: "20px",
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
      //   padding: theme.spacing(3),
    },
    card: {
      height: "100%",
      padding: theme.spacing(1),
    },
    card_grid: {
      // wordSpacing:3,
      justifyContent: "space-between",
    },
    input: {
      padding: "1px",
    },
  })
);

interface Props {
  children: any;
  agentsList: any;
  bookingList: any;
  partnerList: any;
  getAgentList: any;
  getPartners: any;
  getAllBookings: any;
  getCities: any;
  cities: any;
  getPhlebos: any;
  phleboList: any;
  getLeadSource: any;
  lead_source: any;
  loading: Boolean;
  getCenterInfo: any;
  centerInfo: any;
}

const GenomicsAdminFilterPage: React.FC<Props> = ({
  agentsList,
  partnerList,
  getAgentList,
  getPartners,
  getAllBookings,
  bookingList,
  getCities,
  cities,
  getPhlebos,
  phleboList,
  getLeadSource,
  lead_source,
  loading,
  getCenterInfo,
  centerInfo,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [openModal, setopenModal] = useState<boolean>(false);
  const [bookingId, setBookingId] = useState<any>("");
  const [status, setStatus] = useState<String>("none");
  const [source, setSource] = useState<any>([]);
  const [partner, setPartner] = useState<number>(0);
  const [agent, setAgent] = useState<number>(0);
  const [city, setCity] = useState<any>([]);
  const [start_date, setStart_date] = useState("");
  const [report_status, setReportStatus] = useState<any>("none");
  const [end_date, setEnd_date] = useState("");
  const [booking_date, setBooking_date] = useState("");
  const [salesPerson, setSalesPerson] = useState("")
  const [collection_date, setCollection_date] = useState("");
  const [verificationStatus, setVerificationStatus] = useState<any>([]);
  const [pickup_status, setPickup_status] = useState("none");
  const [name, setName] = useState("");
  const [qrcode, setqrCode] = useState<any>("");
  const [phlebo, setPhlebo] = useState<number>(0);
  const [mobileNumber, setMobileNumber] = useState("");
  const [defaultStatus, setDefaultStatus] = useState<any>([]);
  const [mobileValidation, setMobileValidation] = useState<any>({
    mobileNumber: true,
  });
  const [center, setCentre] = useState<any>("");
  const [page, setPage] = useState(0);

  const timer = useRef<any>(0);

  const verifyMobile = (type: any) => {
    const mobileRegEx = /^[6-9]\d{9}$/;
    if (
      type === "mobile_number" &&
      !mobileRegEx.test(mobileNumber.toString())
    ) {
      setMobileValidation((prev: any) => ({
        ...prev,
        mobileNumber: false,
      }));
    }
  };

  useEffect(() => {
    //getAgentList();
    // getPartners();
    getAllBookings();
    getCities();
    getPhlebos();
    getLeadSource();
    getCenterInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const filterBookings = (e:any) => {
    const body: any = {
      bookingId,
      center_type: center,
      status,
      verificationStatus,
      source: source.join(","),
      agent: salesPerson,
      city,
      start_date,
      end_date,
      booking_date,
      collection_date,
      name,
      phlebo,
      partner,
      mobile: mobileNumber,
      qrcode,
      report_status,
      pickup_status,

    };
    const url = generateBookingFilterUrl(body).substring(2);
    getAllBookings(url);
    setPage(0);
  };
  const onKeyDown = (e: any) => {
    if (e.key === "Enter") {
      filterBookings(e);
    }
  };
  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Grid
          container
          spacing={2}
          direction="row"
          style={{ alignItems: "right" }}
        >
          <Grid item xs={12} sm={8}>
            <h4 style={{ fontWeight: "bold" }}>GENOMICS ADMIN DASHBOARD</h4>
          </Grid>
          {/* <Grid item xs={12} sm={4}>
            <h4 style={{ fontWeight: "bold" }}>BOOKING COUNT : {totalCount}</h4>
          </Grid> */}
        </Grid>
        <Grid
          container
          spacing={3}
          direction="row"
          style={{ alignItems: "left" }}
        >
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              className="input"
              name="name"
              type="text"
              label="Booking Id"
              value={bookingId}
              variant="outlined"
              onChange={(e) => setBookingId(e.target.value as string)}
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              name="booking_date"
              type="date"
              value={start_date === "" || end_date === "" ? booking_date : ""}
              className="input"
              label="Booking Date"
              variant="outlined"
              disabled={start_date !== "" || end_date !== ""}
              onChange={(e) => setBooking_date(e.target.value as string)}
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              className="input"
              name="name"
              type="text"
              label="Name"
              value={name}
              variant="outlined"
              onChange={(e) => setName(e.target.value as string)}
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              className="input"
              fullWidth
              id="mobile-number"
              label="Mobile Number"
              variant="outlined"
              type="number"
              inputProps={{ maxLength: 10 }}
              value={mobileNumber || ""}
              onChange={(e) =>
                setMobileNumber(
                  Math.max(0, parseInt(e.target.value)).toString().slice(0, 10)
                )
              }
              onBlur={() => verifyMobile("mobile_number")}
              onFocus={() => {
                setMobileValidation((prev: any) => ({
                  ...prev,
                  mobileNumber: true,
                }));
              }}
              helperText={
                !mobileValidation.mobileNumber && "Incorrect Phone Number"
              }
            />
          </Grid>
          {/* <Grid item xs={12} sm={4} md={2}>
            <TextField
              className="input"
              name="Barcode"
              type="text"
              label="Barcode"
              value={qrcode}
              variant="outlined"
              onChange={(e) => setqrCode(e.target.value as string)}
              style={{ width: "100%" }}
            />
          </Grid> */}
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              className="input"
              name="start_date"
              type="date"
              label="Start Date"
              value={
                booking_date === "" || collection_date === "" ? start_date : ""
              }
              variant="outlined"
              disabled={booking_date !== "" || collection_date !== ""}
              onChange={(e) => setStart_date(e.target.value as string)}
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              name="end_date"
              type="date"
              value={
                booking_date === "" || collection_date === "" ? end_date : ""
              }
              className="input"
              label="End Date"
              variant="outlined"
              disabled={booking_date !== "" || collection_date !== ""}
              onChange={(e) => setEnd_date(e.target.value as string)}
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Select
              className="input"
              name="sampleregisterd"
              variant="outlined"
              value={report_status}
              style={{ width: "100%", margin: "0" }}
              onChange={(e) => setReportStatus(e.target.value as String)}
            >
              <MenuItem disabled value={"none"}>
                Report Status
              </MenuItem>
              <MenuItem value={"na"}>None</MenuItem>
              <MenuItem value={"pending"}>Pending</MenuItem>
              <MenuItem value={"partial"}>Partial</MenuItem>
              <MenuItem value={"consolidate"}>Consolidate</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              id="city"
              onChange={(event, newValue) => {
                let sourceIds: any = [];
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  sourceIds = obj.map((item: any) => item.id);
                }
                setCity(sourceIds);
              }}
              options={cities || []}
              freeSolo
              blurOnSelect
              aria-required
              limitTags={1}
              multiple
              getOptionLabel={(option: any) => option?.display_name}
              getOptionDisabled={(option: any) => {
                return city.includes(option.id);
              }}
              disableClearable
              disableCloseOnSelect
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  getCities(newInputValue);
                }, 1000);
                if (newInputValue.length === 0) {
                  setCity([]);
                }
              }}
              renderInput={(params) => (
                <TextField
                  className={classes.input}
                  {...params}
                  label="City"
                  variant="outlined"
                  style={{ width: "100%", margin: "0", padding: "0" }}
                />
              )}
            />
          </Grid>
          {/* <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              id="city"
              onChange={(event, newValue) => {
                let sourceIds: any = [];
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  sourceIds = obj.map((item: any) => item.value);
                }
                setVerificationStatus(sourceIds);
              }}
              options={[
                {
                  text: "Pending",
                  value: "pending",
                },
                {
                  text: "Confirmed",
                  value: "confirmed",
                },
                {
                  text: "Cancelled",
                  value: "cancelled",
                },
              ]}
              freeSolo
              blurOnSelect
              aria-required
              limitTags={1}
              multiple
              getOptionLabel={(option: any) => option.text}
              getOptionDisabled={(option: any) => {
                return verificationStatus.includes(option.value);
              }}
              disableClearable
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  className={classes.input}
                  {...params}
                  label="Verification Status"
                  variant="outlined"
                  style={{ width: "100%", margin: "0", padding: "0" }}
                />
              )}
            />
          </Grid> */}
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              id="city"
              onChange={(event, newValue) => {
                let sourceIds: any = [];
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  sourceIds = obj.map((item: any) => item.value);
                }
                setPickup_status(sourceIds);
              }}
              options={[
                {
                  text: "Pending",
                  value: "pending",
                },
                {
                  text: "Confirmed",
                  value: "confirmed",
                },
                {
                  text: "Cancelled",
                  value: "cancelled",
                },
                {
                  text: "Hold",
                  value: "hold",
                },
              ]}
              freeSolo
              blurOnSelect
              aria-required
              limitTags={1}
              multiple
              getOptionLabel={(option: any) => option.text}
              getOptionDisabled={(option: any) => {
                return pickup_status.includes(option.value);
              }}
              disableClearable
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  className={classes.input}
                  {...params}
                  label="Pickup Status"
                  variant="outlined"
                  style={{ width: "100%", margin: "0", padding: "0" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              id="status"
              onChange={(event, newValue) => {
                let sourceIds: any = [];
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  sourceIds = obj.map((item: any) => item.value);
                }
                setStatus(sourceIds);
              }}
              options={BILLING_STATUS || []}
              blurOnSelect
              aria-required
              onKeyDown={onKeyDown}
              limitTags={1}
              multiple
              getOptionLabel={(option: any) => option.text}
              getOptionDisabled={(option: any) => {
                return status.includes(option.value);
              }}
              disableClearable
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  className={classes.input}
                  {...params}
                  label="Booking Status"
                  variant="outlined"
                  style={{ width: "100%", margin: "0", padding: "0" }}
                />
              )}
              defaultValue={defaultStatus}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              id="center_type"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setCentre(obj.id);
                }
              }}
              freeSolo
              blurOnSelect
              options={centerInfo?.results}
              disableCloseOnSelect
              getOptionLabel={(option: any) =>
                (option?.display_name === null
                  ? option?.name
                  : option?.display_name) +
                "(" +
                option?.center_code +
                ")"
              }
              onInputChange={(event, newInputValue) => {
                getCenterInfo(`&name_or_code=${newInputValue}`);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Hospital/Doctor"
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          <Grid
            container
            spacing={2}
            direction="row"
            alignItems="center"
            justify="center"
          >
            <Grid item xs={12} sm={4} md={2}>
              <Button
                variant="contained"
                color="secondary"
                style={{ height: "56px" }}
                fullWidth
                onClick={filterBookings}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Button
                variant="contained"
                color="primary"
                style={{ height: "56px" }}
                fullWidth
                onClick={() => history.push("/dashboard/gnadmin")}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            Note:
            <small>
              <ul style={{ paddingLeft: "15px" }}>
                <li>You can filter by booking date or start and end date.</li>
                <li>You can filter leads when bookings are available.</li>

              </ul>
            </small>

            <div style={{ alignItems: "left", display: "inline-block", margin: "1rem" }}>
              <div className="r-cl" style={{ display: "flex" }}><div className="boxStyle" style={{ border: "1px solid", width: "17px", height: "17px", background: "#00bcd4" }}></div><div style={{ marginLeft: "5px" }}>Home Collection Bookings </div></div>
              {/* <div className="r-cl" style={{ display: "flex" }}><div className="boxStyle" style={{ border: "1px solid", width: "17px", height: "17px", background: "#f48fb1" }}></div><div style={{ marginLeft: "5px" }}>B2B booking and Payable Amount is not Zero and Phlebo Not Reached</div></div> */}
            </div>

          </Grid>
        </Grid>
        <br />
        {loading ? (
          <Loader />
        ) : (
          bookingList.results &&
          bookingList.results.length > 0 && (
            <Box>
              <Container maxWidth={false}>
                <Grid container spacing={3}>
                  <BookingsTable
                    setopenModal={setopenModal}
                    openModal={openModal}
                    page={page}
                    setPage={setPage}
                    loading={loading}
                    getBookings={getAllBookings}
                    bookingList={bookingList}
                  />
                </Grid>
              </Container>
            </Box>
          )
        )}
        {bookingList.results && bookingList.results.length === 0 && (
          <h6 style={{ textAlign: "center" }}>No Data Found</h6>
        )}
      </main>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  agentsList: state.GenomicsAdminReducer.agentsList,
  partnerList: state.GenomicsAdminReducer.partnerList,
  bookingList: state.GenomicsAdminReducer.bookingList,
  cities: state.GenomicsAdminReducer.cities,
  phleboList: state.GenomicsAdminReducer.phleboList,
  loading: state.GenomicsAdminReducer.loading,
  lead_source: state.GenomicsAdminReducer.lead_source,
});

export default connect(mapStateToProps, {
  getCenterInfo,
  getAgentList,
  getPartners,
  getCities,
  getPhlebos,
  getLeadSource,
  getAllBookings,
})(GenomicsAdminFilterPage);
